import { render, staticRenderFns } from "./contentCourseExamCrosswordGame.vue?vue&type=template&id=6b8051bc&"
import script from "./contentCourseExamCrosswordGame.vue?vue&type=script&lang=js&"
export * from "./contentCourseExamCrosswordGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports